module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1daTSk/tc-custom/9781035869138.jpg?1728726136865",
      "alt": "This image is the cover for the book Elephants in My Salad"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Elephants in My Salad\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Have you ever wanted to get away from it all and escape to the wilds of Africa? Well, this writer did! At the age of 48, she sold her successful South African company to self-build a house on a 4,500-hectare private game reserve in Botswana. Just four hours of electricity a day, no phone, no gun, no fences to keep predators or elephants at bay, and no vet, doctor, dentist, or supermarket within 120 miles! Told with humour (and a taste of just how life-threatening the bush can be,) this collection of personal experiences gives you a real taste of belonging as an integral part of wild Africa. Be immersed in tales of: Wildfires, droughts, and being marooned by rain-swollen rivers! Being charged by angry elephants and being caught between herds of elephants while on foot! Being adopted by a one-tonne land antelope and a two-week old baby elephant! …and how often Caesar saved the day!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Chris Burlock\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Chris never shirked from a challenge. Gay, capable and an achiever, she rapidly made a name for herself in the advertising industry in South Africa, becoming managing director of a below-the-line agency at the age of 26 and retiring at 48 to live in the bush. Passionate about wildlife, Chris transports readers (with humour) into the adventures and trials experienced in a private game reserve in Botswana.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0